import styled from 'styled-components';

export const StyledConfigureModal = styled.div`
  width: 100%;

  .desc {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    padding: 0 0 15px;
  }

  .holder {
    width: 100%;
    margin: 0 0 30px;
  }

  .switcher {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .label {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 600;
    }

    input {
      display: none;

      &:checked ~ {
        .custom-label {
          background: #1a2a6c;

          &::before {
            left: 21px;
          }
        }
      }
    }

    .custom-label {
      display: block;
      position: relative;
      width: 45px;
      height: 26px;
      cursor: pointer;
      border-radius: 50px;
      background: #b0bec5;

      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 22px;
        height: 22px;
        transition: all ease-in-out 0.3s;
        border-radius: 50px;
        background: #eceff1;
      }
    }
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding-top: 15px;
    border-top: 1px solid var(--light-gray);
  }
`;
